<template>
<section>
    <div v-if="loading" class="content content-centered">
        <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
        <div class="box">
            <div class="box-body">
                <div class="row">
                    <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                        <div class="alert" :class="'alert-' + flashType">
                            {{ flashMessage }}
                        </div>
                    </div>
                </div>
                <div class="collection_location_scroll">
                <div id="details" class="row collection_location_inner">
                    <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.cityId)">
                                    <label>City Name</label>
                                    <select required name="cityId" class="form-control" :disabled="($route.params && $route.params._id && $route.params._id != '0') || isCityDisable || ongoingStatus=='Ongoing'" v-model="surveys.cityId" v-on:change="getCityId($event.target.value)" @change="reset()">
                                        <option value="" disabled>Select City Name</option>
                                        <option v-for="cityId in citys" :value="cityId.id">{{ cityId.name }}
                                        </option>
                                    </select>
                                    <field-messages name="cityId" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.wcaId)">
                                    <label>Zone</label>
                                    <select required name="wcaId" class="form-control" :disabled="ongoingStatus=='Ongoing'" v-on:change="getCollectionDivisionPointsList($event.target.value)" 
                                    v-model="surveys.wcaId">
                                        <option value="" disabled>Select Zone</option>
                                        <option v-for="wcap in wasteCollectionAreaPoints" :value="wcap.id">{{ wcap.name }}</option>
                                    </select>
                                    <field-messages name="wcaId" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.wdaId)">
                                    <label>Collection Division</label>
                                    <select required name="wdaId" class="form-control" :disabled="ongoingStatus=='Ongoing'"  v-on:change="getLineAndTowerPointsList($event.target.value)" v-model="surveys.wdaId">
                                        <option value="" disabled>Select Collection Division</option>
                                        <option v-for="collectionDivision in collectionDivisionPoints" :value="collectionDivision.id">{{ collectionDivision.name }}</option>
                                    </select>
                                    <field-messages name="wdaId" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                    </field-messages>
                                </validate>
                            </div>

                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.surveyorId)">
                                    <label>Surveyor</label>
                                    <select required name="surveyorId" class="form-control" v-model="surveys.surveyorId">
                                        <option value="" disabled>Select Surveyor</option>
                                        <option v-for="SurveyorId in surveyorPoints" :value="SurveyorId.id">{{ SurveyorId.name }}</option>
                                    </select>
                                    <field-messages name="surveyorId" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.startDate)">
                                    <label>Schedule Start Date</label>
                                    <date-picker id="startDate" required v-model="surveys.startDate" lang="en" name="startDate" :disabled="ongoingStatus=='Ongoing'" input-class="form-control" width="100%" use-utc="true" format="DD-MM-YYYY" @change="datevalidation" :not-before="disabledBefore"></date-picker>
                                    <field-messages name="startDate" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.endDate)">
                                    <label>Schedule End Date</label>
                                    <date-picker id="endDate" required v-model="surveys.endDate" lang="en" name="endDate" :disabled="ongoingStatus=='Ongoing'" input-class="form-control" width="100%" use-utc="true" format="DD-MM-YYYY" @change="datevalidation1" :not-before="notBeforeEndDate" :not-after="disabledAfter" ></date-picker>
                                    <!-- :disabled="isEndDateDisable" -->
                                    <field-messages name="endDate" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                        </div>

                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group" :class="fieldClassName(formstate.lineTower)">
                                    <label>Line / Tower</label>
                                    <multiselect track-by="name" label="name" v-model="surveys.lineTower" :disabled="ongoingStatus=='Ongoing'"  :options="lineTowerPoints" multiple name="lineTower" @input="isInputEvent"></multiselect>
                                </validate>
                            </div>
                        </div>

                        <!-- <div class="col-sm-12">
                              <div class="col-sm-6">
                                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.lineTower)">
                                      <label>Line/Tower</label>
                                      <multiselect track-by="name" label="name" v-model="surveys.lineTower" :options="lineTowerPoints" multiple name="lineTower" required></multiselect>
                                      <field-messages name="lineTower" show="$touched || $submitted" class="form-control-feedback">
                                          <div slot="required">This is required field</div>
                                      </field-messages>
                                  </validate>
                              </div>
                          </div> -->
                    </vue-form>

                    <div class="col-sm-12 text-right">
                        <router-link :to="{ name: 'surveys' }">
                            <button class="mr-5 btn btn-default" type="button">
                                Cancel
                            </button>
                        </router-link>
                        <button class="mr-2 btn gradientbt" type="submit" @click="createSurveys" :disabled="!(formstate.$dirty && formstate.$valid)" v-if="$route.params && $route.params._id == '0'">
                            Save
                        </button>
                        <button class="btn gradientbt mr-5" type="submit" @click="updateSurveys" :disabled="!(formstate.$dirty && formstate.$valid)" v-if="$route.params && $route.params._id != '0'">
                            Update
                        </button>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import axios from "axios";
import store from "../../../store";
import {
    formService,
    eventBus,
    surveysService,
    wasteCollectionAreaService,
    fileService,
} from "../../../services";
import {
    EVENTS
} from "../../../config";
import {
    USER_ROLES
} from "../../../config";
import {
    mapState
} from "vuex";
import {
    Multiselect
} from "vue-multiselect";

export default {
    name: "surveysCreate",
    components: {
        Multiselect,
    },
    data() {
        return {
            // isInputChange: false,
            ongoingStatus:{},
            isEndDateDisable: true,
            isCityDisable: false,
            ready: false,
            USER_ROLES: USER_ROLES,
            loading: false,
            endDateFormat: null,
            disabledAfter: null,
            disabledBefore: new Date(),
            disabledStartDate: new Date(),
            notBeforeEndDate: null,
            flash: false,
            flashType: null,
            flashMessage: "",
            endDateIso: "",
            startDateIso: "",
            EVENTS: EVENTS,
            formstate: {},
            surveys: {
                cityId: "",
                wcaId: "",
                wdaId: "",
                surveyorId: "",
            },
            oldSurveys: {},
            surveysId: [],
            data: {},
            wasteCollectionAreaPoints: {},
            collectionDivisionPoints: {},
            surveyorPoints: {},
            lineTowerPoints: [],
            docs: null,
            divisions: [],
            citys: {},
            lineIds: [],
        };
    },

    mounted() {
            this.getCityList();
            eventBus.$on('cityIdChanged', this.onChecked);
            if(this.$store.state.auth.user.role.key !== "cityAdmin" || this.$store.state.auth.user.role.key !== "subCityAdmin"){
                this.isCityDisable = true
                this.surveys.cityId = this.$store.state.auth.cityId.value
               
                this.getCityId(this.$store.state.auth.cityId.value)
                // this.getWasteCollectionAreaPointsList(cityId);
                // this.getSurveyoys(cityId);
            }
        },
        beforeDestroy() {
            eventBus.$off('cityIdChanged', this.onChecked);
        },

    methods: {
        fieldClassName: formService.fieldClassName,

        isInputEvent(value) {
            this.formstate.lineTower.$dirty = true;
            this.formstate.lineTower.$touched = true;

        },
        onChecked(option){
            this.surveys.cityId = option.value
            this.getCityId(option.value)
        },
        datevalidation(event) {
            this.notBeforeEndDate = new Date(event).toISOString();
            let d = new Date(event).toISOString();
            var date = new Date(d);
            let startEpoch = date.getTime();
            if (this.endDateFormat) {
                let endEpoch = this.endDateFormat.getTime();
                if (startEpoch && endEpoch && startEpoch > endEpoch) {
                    this.surveys.endDate = "";
                }
            }

            this.disabledAfter = new Date(date.setMonth(date.getMonth() + 3));
            this.isEndDateDisable = false;
        },

        datevalidation1(event) {
            let d = new Date(event).toISOString();
            var date = new Date(d);
            this.endDateFormat = date;
        },

        getCityList() {
            if (this.$store.state.auth.user.role.key === "cityAdmin" || this.$store.state.auth.user.role.key === "superVisor" || this.$store.state.auth.user.role.key === "subCityAdmin") {
                const {
                    _id,
                    cityName
                } = this.$store.state.auth.user.cityId;
                this.citys = [{
                    id: _id,
                    name: cityName,
                }, ];
                this.surveys["cityId"] = _id;
                this.isCityDisable = true;
                this.getWasteCollectionAreaPointsList(_id);
                this.getSurveyoys(_id);
                return;
            }
            this.loading = true;
            const params = {};
            let cityList = [];

            this.$cityRepository
                .collectionCitysList(params)
                .then((res) => {
                    this.loading = false;
                    res.data.response.forEach((element) => {
                        if (element.status === true) {
                            cityList.push({
                                name: element.cityName,
                                id: element._id,
                            });
                        }
                    });
                    cityList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.citys = cityList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("citys.requestFunction-error:", error);
                    this.$snotify.error("Get citys list failed", "Error!");
                });
        },

        getWasteCollectionAreaPointsList(cityId) {
            this.loading = true;
            let areaList = [];
            return surveysService
                .getWasteCollectionAreaList(cityId)
                .then((res) => {
                    this.loading = false;
                    res.data.response.forEach((element) => {
                        if (element.status === true && element.cityId === cityId) {
                            areaList.push({
                                name: element.areaName,
                                id: element._id,
                            });
                        }
                    });
                    areaList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.wasteCollectionAreaPoints = areaList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error(
                        "Ward Details Points.requestFunction-error:",
                        error
                    );
                    this.$snotify.error(
                        "Get Ward Details Points List failed",
                        "Error!"
                    );
                });
        },

        getCollectionDivisionPointsList(event) {
            this.loading = true;
            this.surveys["wdaId"] = [];
            this.surveys["lineTower"] = [];
            this.lineTowerPoints = [];
            let divisionList = [];

            return surveysService
                .getCollectionDivisionList(event)
                .then((response) => {
                    // this.divisions = response.data.response
                    response.data.response.forEach((element) => {
                        element.Divisions.forEach((a) => {
                            divisionList.push({
                                name: a.cdName,
                                id: a._id,
                            });
                        });
                    });
                    divisionList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.collectionDivisionPoints = divisionList;
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("Collection Division Points List-error:", error);
                    // this.$snotify.error('Update user failed', 'Error!');
                });
        },

        getLineAndTowerPointsList(event) {
            this.loading = true;
            let lineAndTowerList = [];
            let ids = [event];
            return surveysService
                .getLineAndTowerList(ids)
                .then((response) => {
                    response.data.response.forEach((element) => {
                        if (element.status == true) {
                            lineAndTowerList.push({
                                name: element.name,
                                id: element._id,
                            });
                        }

                        // element.lineTowerHouse.forEach((a) => {
                        //     lineAndTowerList.push({
                        //         name: a.name,
                        //         id: a._id,
                        //     });
                        // });
                    });
                    lineAndTowerList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.lineTowerPoints = lineAndTowerList;
                    let selectedLine = [];
                    this.lineTowerPoints.forEach((element) => {
                        this.lineIds.forEach((ele) => {
                            if (element.id === ele._id) {
                                selectedLine.push({
                                    name: element.name,
                                    id: element.id,
                                });
                            }
                        });
                    });
                    this.surveys["lineTower"] = selectedLine;
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("Line and Tower Points List-error:", error);
                });
        },

        getSurveyoys(cityId) {
            this.loading = true;
            let surveyoysList = [];
            return surveysService
                .getSurveyoysList(cityId)
                .then((response) => {
                    response.data.response.forEach((element) => {
                        if ((element.cityId = cityId)) {
                            surveyoysList.push({
                                name: element.firstName + " " + element.lastName,
                                id: element._id,
                            });
                        }
                    });
                    surveyoysList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.surveyorPoints = surveyoysList;
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("Surveyoys-error:", error);
                });
        },

        createSurveys() {
            this.loading = true;
            this.data = {};
            this.data["cityId"] = this.surveys["cityId"];
            this.data["wcaId"] = this.surveys["wcaId"];
            this.data["wdaId"] = this.surveys["wdaId"];
            this.data["startDate"] = this.surveys["startDate"];
            this.data["endDate"] = this.surveys["endDate"];
            this.data["surveyorId"] = this.surveys["surveyorId"];
            if (this.surveys["lineTower"]) {
                this.data["lineTower"] = this.surveys["lineTower"].map((el) => el.id);
            }
            return surveysService
                .addSurveys(this.data)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.$snotify.success(`The Survey has been added successfully.`);
                    this.$router.push("/surveys");
                })
                .catch((error) => {
                    this.loading = false;
                    if (error.data && error.data.message) {
                        this.$snotify.error(error.data.message, "Error!");
                    } else {
                        this.$snotify.error(error, "Error!");
                    } 
                    
                   
                });
        },

        clearChanges() {
            this.surveys = _.cloneDeep(this.oldSurveys);
            this.formstate._reset();
        },

        updateSurveys() {
            const id = this.$route.params._id;
            this.loading = true;
            this.data = {};
            this.data["cityId"] = this.surveys["cityId"];
            this.data["wcaId"] = this.surveys["wcaId"];
            this.data["wdaId"] = this.surveys["wdaId"];
            this.data["startDate"] = this.surveys["startDate"];
            this.data["endDate"] = this.surveys["endDate"];
            this.data["surveyorId"] = this.surveys["surveyorId"];
            this.data["status"] = this.surveys["status"];
            if (this.surveys["lineTower"]) {
                this.data["lineTower"] = this.surveys["lineTower"].map((el) => el.id);
            }
            this.data["_id"] = this.$route.params._id;

            return surveysService
                .updateSurveys(id, this.data)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.formstate._reset();
                    this.oldSurveys = _.cloneDeep(this.surveys);
                    this.$snotify.success(`The Survey has been updated successfully.`);
                    this.$router.push("/surveys");
                })
                .catch((error) => {
                    this.loading = false;
                    if (error.data && error.data.message) {
                        this.$snotify.error(error.data.message, "Error!");
                    } else {
                        this.$snotify.error("Update Surveys failed", "Error!");
                    }                   
                    console.error("Surveys.Update Surveys-error:", error);
                    // this.$snotify.error("Update Surveys failed", "Error!");
                    if (error.data.message.includes("must be one of")) {
                        this.flash = true;
                        this.flashType = "error";
                        this.flashMessage =
                            "That surveys name is not allowed. You must first update the list of allowed surveys names" +
                            " in the appy client and server config.";
                    }
                });
        },
        getSurveyoy() {
            const params = {};
            let surveyoyss = [];
            return surveysService
                .getById(this.$route.params._id, params)
                .then((response) => {
                    this.isEndDateDisable = false;
                    surveyoyss = response.data.response;
                    this.getCityId(response.data.response.cityId);
                    surveyoyss["wcaId"] = response.data.response.wasteCollectionAreaId;
                    surveyoyss["wdaId"] = response.data.response.wasteDivisionAreaId;
                    // surveyoyss["startDate"]
                    this.startDateIso = response.data.response.startDate;
                    this.endDateIso = response.data.response.endDate;
                    let sDate = new Date(
                        response.data.response.startDate
                    ).toLocaleDateString();
                    const eventData = sDate.split("/");
                    const startDate =
                        eventData[1] + "-" + eventData[0] + "-" + eventData[2];
                    surveyoyss["startDate"] = response.data.response.startDate;
                    let eDate = new Date(
                        response.data.response.endDate
                    ).toLocaleDateString();
                    const getEndData = eDate.split("/");
                    let d = new Date(response.data.response.endDate).toISOString();
                    const date = new Date(d);
                    this.endDateFormat = date;
                    let datestart = new Date(response.data.response.startDate).toISOString();
                    const dateStartt = new Date(datestart);
                    this.notBeforeEndDate = dateStartt
                    const endDate =
                        getEndData[1] + "-" + getEndData[0] + "-" + getEndData[2];
                    surveyoyss["endDate"] = response.data.response.endDate;

                    this.lineIds = response.data.response.collectionDivisionAreasData;
                    this.getCollectionDivisionPointsList(surveyoyss.wcaId);

                    this.getLineAndTowerPointsList(surveyoyss.wdaId);
                    this.surveys = surveyoyss;

                    this.oldWasteRecycle = _.cloneDeep(this.surveys);
                })
                .catch((error) => {
                    console.error("Waste recycle-error:", error);
                    this.$snotify.error("Get Waste recyclefailed", "Error!");
                });
        },
        getCityId(cityId) {
            this.surveys.wcaId = "";
            this.surveys.wdaId = "";
            this.surveys.surveyorId = "";
            this.getWasteCollectionAreaPointsList(cityId);
            this.getSurveyoys(cityId);
        },
        reset() {
            this.wasteCollectionAreaPoints = {};
            this.collectionDivisionPoints = {};
            this.surveys.startDate = "";
            if (this.surveys.endDate) {
                this.surveys.endDate = "";
            }
            this.surveys.lineTower = [];
            this.lineTowerPoints = [];
            this.formstate._reset();
        }
    },

    created() {
       
        if(this.$route.params.props == 'Ongoing'){
        this.ongoingStatus = this.$route.params.props;
    }
        
        const promises = [];
        this.loading = true;
        if (
            this.$route.params &&
            this.$route.params._id &&
            this.$route.params._id != "0"
        ) {
            promises.push(this.getSurveyoy());
        }
        Promise.all(promises)
            .then(() => {
                this.loading = false;
                this.ready = true;
            })
            .catch(() => {
                this.loading = false;
            });
            
    },
   

    fieldClassName: function (field) {
        if (!field) {
            return "";
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return "has-success";
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return "has-danger";
        }
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.required-field>label::after {
    content: "*";
    color: red;
    margin-left: 0.25rem;
}

.form-control-feedback {
    font-weight: 100;
    color: red;
    position: initial;
    text-align: left;
    height: auto;
    width: auto;
}

.has-danger {
    color: red;
}

.mt {
    margin-top: 7px;
}

.gradientbt {
    background: #0f6940;
    color: white;
}

.inputwrapper {
    position: relative;
}

.maps {
    position: absolute;
    top: 7px;
    right: 10px;
}
</style>



// WEBPACK FOOTER //
// surveysCreate.vue?22d2f1d2